import { VueRenderer } from '@tiptap/vue-2'
import tippy from 'tippy.js'

import MentionList from './MentionList.vue'

export default {
    items: ({ query }) => {
        let mentionsList = getMentionable();
        return mentionsList.filter(item => item.name?.toLowerCase().startsWith(query.toLowerCase())).slice(0, 5)
    },

    render: () => {
        let component
        let popup

        return {
            onStart: props => {
                component = new VueRenderer(MentionList, {
                    // using vue 2:
                    parent: this,
                    propsData: props,
                    editor: props.editor,
                })

                if (!props.clientRect) {
                    return
                }

                popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start',
                })
            },

            onUpdate(props) {
                component.updateProps(props)

                if (!props.clientRect) {
                    return
                }

                popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                })
            },

            onKeyDown(props) {
                if (props.event.key === 'Escape') {
                    popup[0].hide()

                    return true
                }

                return component.ref?.onKeyDown(props)
            },

            onExit() {
                popup[0].destroy()
                component.destroy()
            },
        }
    },
}

function getMentionable() {

    let mentionsChecked = window.sessionStorage.getItem('cm:mentionsChecked') == window.savedMarkup.uuid ?? false;

    if (mentionsChecked) {
        setTimeout(fetchList, 400)
    } else {
        fetchList()
    }

    return JSON.parse(window.localStorage.getItem('cm:mentionsList') ?? "[]");
}

function fetchList() {
    axios.get(`/comments/${window.savedMarkup.uuid}/mentions`)
        .then(response => {
            window.sessionStorage.setItem('cm:mentionsChecked', window.savedMarkup.uuid)

            if (response.status == 'empty') {
                return
            }

            let userList = response.data.data;

            window.localStorage.setItem('cm:mentionsList', JSON.stringify(userList))
        })
        .catch(error => {
            // if it's possible to recover from the error then it should set mentioncheckd false.
        })
}
